<template>
<div>
  <DIV
    :key="index"
    class="d-flex flex-col form-row"
    v-for="(item, index) in items"
  >
    <div
      class="col-auto"
      v-if="items.length > 1"
    >
      #{{ index+1 }}
    </div>
    <div
      class="col"
    >
      <DIV
        class="mb-2"
      >
        <ItpFormInput
          name="message"
          v-model="item.message"
          required
          :readonly="readonly"
          :title="'The message to include to the invoice.'|pgettext('TransactionNotesEditor')"
          @input="evh_5534025912102772_input($event, {item, index})"
        >
        </ItpFormInput>
      </DIV>
      <DIV
        class="form-row align-items-center"
      >
        <div
          class="col-3"
        >
          <ItpFormDatetime
            name="valid_from"
            v-model="item.valid_from"
            :readonly="readonly"
            :placeholder="'Valid from'|pgettext('TransactionNotesEditor')"
            :title="'Valid from'|pgettext('TransactionNotesEditor')"
            @input="evh_309515315410323_input($event, {item, index})"
          >
          </ItpFormDatetime>
        </div>
        <div
          class="col-3"
        >
          <ItpFormDatetime
            name="valid_to"
            v-model="item.valid_to"
            :readonly="readonly"
            :placeholder="'Valid to'|pgettext('TransactionNotesEditor')"
            :title="'Valid to'|pgettext('TransactionNotesEditor')"
            @input="evh_5188750589197515_input($event, {item, index})"
          >
          </ItpFormDatetime>
        </div>
        <div
          class="col-3"
        >
          <ItpFormInput
            name="counter"
            type="number"
            v-model="item.counter"
            :readonly="readonly"
            :placeholder="'Counter'|pgettext('TransactionNotesEditor')"
            :title="'Counter'|pgettext('TransactionNotesEditor')"
            @input="evh_3475726502813997_input($event, {item, index})"
          >
          </ItpFormInput>
        </div>
        <div
          class="col-3"
        >
          <ItpFormInput
            name="max_displays"
            type="number"
            v-model="item.max_displays"
            :readonly="readonly"
            :placeholder="'Max displays'|pgettext('TransactionNotesEditor')"
            :title="'Max displays'|pgettext('TransactionNotesEditor')"
            @input="evh_4449693688767071_input($event, {item, index})"
          >
          </ItpFormInput>
        </div>
      </DIV>
    </div>
    <div
      class="col-auto"
      v-if="!readonly && !disabled"
    >
      <button
        data-dismiss="modal"
        aria-label="Close"
        :title="'Remove'|pgettext('TransactionNotesEditor')"
        class="close"
        @click.prevent.stop="evh_1548630417156826_clickPreventStop($event, {item, index})"
      >
        <span aria-hidden="true">&times;</span>

      </button>
    </div>
  </DIV>
  <DIV
    class="d-flex mt-2 align-items-center"
    v-if="!readonly && !disabled"
  >
    <DIV
      @click.prevent.stop="evh_96700093353179_clickPreventStop($event, {})"
    >
      <ItpLink
        :icon="$config.addIcon"
        :text="'Add'|pgettext('TransactionNotesEditor')"
      >
      </ItpLink>
    </DIV>
  </DIV>
</div>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class TransactionNotesEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  getItems(...args: any[]) {
    const value = this.value;

    if (this._items && value === this._items) {
      return this._items;
    }

    if (value == null || value.length == 0) {
      this._items = [];
      return this._items;
    }

    this._items = value;
    return value
  }

  addItem(...args: any[]) {
    this.items.push(this.newItem())
    this.emitChange()
  }

  newItem(...args: any[]) {
    return {
      message: null,
      valid_from: null,
      valid_to: null,
      counter: null,
      max_displays: null,
    }
  }

  removeItem(...args: any[]) {
    const [item] = args;

    const removed = _.remove(this._items, p => p === item);
    if (removed && removed.length) {
      this.emitChange();
    }
  }

  emitChange(...args: any[]) {
    this._items = this.items.slice();
    this.items = this._items;
    this.$emit('input', this._items);
  }

  @Prop({
    type: Array,
  })
  value!: array;

  @Watch('value')
  onValue(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("value")
  }

  @Prop({
    type: String,
    default: "right",
  })
  labelAlign!: string;

  @Watch('labelAlign')
  onLabel_align(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("labelAlign")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  @Prop({
    type: Boolean,
  })
  disabled!: boolean;

  @Watch('disabled')
  onDisabled(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("disabled")
  }

  items!: any;

  async $$load_items() {
    return this.getItems()
  }

  ux!: any;
  dataMembers = ['items', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        items: null,
        ux: null,
      },
    }
  }

  async act_5534025912102772_script_2542_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5534025912102772_script_2542, alias=undefined
    this.emitChange()
  }

  async act_5534025912102772_script_2542_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5534025912102772_script_2542, alias=undefined
    return {
      value: () => this.act_5534025912102772_script_2542_getActionArgs_value($event),
    }
  }

  async evh_5534025912102772_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5534025912102772_input.executeFromDOM(this, event, scope);
  }

  async act_309515315410323_script_2544_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_309515315410323_script_2544, alias=undefined
    this.emitChange()
  }

  async act_309515315410323_script_2544_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_309515315410323_script_2544, alias=undefined
    return {
      value: () => this.act_309515315410323_script_2544_getActionArgs_value($event),
    }
  }

  async evh_309515315410323_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_309515315410323_input.executeFromDOM(this, event, scope);
  }

  async act_5188750589197515_script_2546_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_5188750589197515_script_2546, alias=undefined
    this.emitChange()
  }

  async act_5188750589197515_script_2546_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_5188750589197515_script_2546, alias=undefined
    return {
      value: () => this.act_5188750589197515_script_2546_getActionArgs_value($event),
    }
  }

  async evh_5188750589197515_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5188750589197515_input.executeFromDOM(this, event, scope);
  }

  async act_3475726502813997_script_2548_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_3475726502813997_script_2548, alias=undefined
    this.emitChange()
  }

  async act_3475726502813997_script_2548_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_3475726502813997_script_2548, alias=undefined
    return {
      value: () => this.act_3475726502813997_script_2548_getActionArgs_value($event),
    }
  }

  async evh_3475726502813997_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_3475726502813997_input.executeFromDOM(this, event, scope);
  }

  async act_4449693688767071_script_2550_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_4449693688767071_script_2550, alias=undefined
    this.emitChange()
  }

  async act_4449693688767071_script_2550_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_4449693688767071_script_2550, alias=undefined
    return {
      value: () => this.act_4449693688767071_script_2550_getActionArgs_value($event),
    }
  }

  async evh_4449693688767071_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4449693688767071_input.executeFromDOM(this, event, scope);
  }

  async act_1548630417156826_script_2552_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_1548630417156826_script_2552, alias=undefined
    this.removeItem($event.scope.item)
  }

  async act_1548630417156826_script_2552_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_1548630417156826_script_2552, alias=undefined
    return {
      value: () => this.act_1548630417156826_script_2552_getActionArgs_value($event),
    }
  }

  async evh_1548630417156826_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async act_96700093353179_script_2554_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_96700093353179_script_2554, alias=addItem
    this.addItem()
  }

  async act_96700093353179_script_2554_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_96700093353179_script_2554, alias=addItem
    return {
      value: () => this.act_96700093353179_script_2554_getActionArgs_value($event),
    }
  }

  async evh_96700093353179_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_96700093353179_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_5534025912102772_script_2542: actions.ScriptAction;
    evh_5534025912102772_input_2541: actions.EventHandlerImpl;
    evh_5534025912102772_input: actions.EventHandlerGroup;
    act_309515315410323_script_2544: actions.ScriptAction;
    evh_309515315410323_input_2543: actions.EventHandlerImpl;
    evh_309515315410323_input: actions.EventHandlerGroup;
    act_5188750589197515_script_2546: actions.ScriptAction;
    evh_5188750589197515_input_2545: actions.EventHandlerImpl;
    evh_5188750589197515_input: actions.EventHandlerGroup;
    act_3475726502813997_script_2548: actions.ScriptAction;
    evh_3475726502813997_input_2547: actions.EventHandlerImpl;
    evh_3475726502813997_input: actions.EventHandlerGroup;
    act_4449693688767071_script_2550: actions.ScriptAction;
    evh_4449693688767071_input_2549: actions.EventHandlerImpl;
    evh_4449693688767071_input: actions.EventHandlerGroup;
    act_1548630417156826_script_2552: actions.ScriptAction;
    evh_1548630417156826_clickPreventStop_2551: actions.EventHandlerImpl;
    evh_1548630417156826_clickPreventStop: actions.EventHandlerGroup;
    act_96700093353179_script_2554: actions.ScriptAction;
    evh_96700093353179_clickPreventStop_2553: actions.EventHandlerImpl;
    evh_96700093353179_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_5534025912102772_script_2542 = new actions.ScriptAction(
      {
        actionArgs: this.act_5534025912102772_script_2542_getActionArgs,
        events: [],
      }
    );
    const evh_5534025912102772_input_2541 = new actions.EventHandlerImpl(
      {
        action: act_5534025912102772_script_2542,
        event: "input",
        displayName: "script",
      }
    );
    const evh_5534025912102772_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_5534025912102772_input_2541],
      }
    );
    const act_309515315410323_script_2544 = new actions.ScriptAction(
      {
        actionArgs: this.act_309515315410323_script_2544_getActionArgs,
        events: [],
      }
    );
    const evh_309515315410323_input_2543 = new actions.EventHandlerImpl(
      {
        action: act_309515315410323_script_2544,
        event: "input",
        displayName: "script",
      }
    );
    const evh_309515315410323_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_309515315410323_input_2543],
      }
    );
    const act_5188750589197515_script_2546 = new actions.ScriptAction(
      {
        actionArgs: this.act_5188750589197515_script_2546_getActionArgs,
        events: [],
      }
    );
    const evh_5188750589197515_input_2545 = new actions.EventHandlerImpl(
      {
        action: act_5188750589197515_script_2546,
        event: "input",
        displayName: "script",
      }
    );
    const evh_5188750589197515_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_5188750589197515_input_2545],
      }
    );
    const act_3475726502813997_script_2548 = new actions.ScriptAction(
      {
        actionArgs: this.act_3475726502813997_script_2548_getActionArgs,
        events: [],
      }
    );
    const evh_3475726502813997_input_2547 = new actions.EventHandlerImpl(
      {
        action: act_3475726502813997_script_2548,
        event: "input",
        displayName: "script",
      }
    );
    const evh_3475726502813997_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_3475726502813997_input_2547],
      }
    );
    const act_4449693688767071_script_2550 = new actions.ScriptAction(
      {
        actionArgs: this.act_4449693688767071_script_2550_getActionArgs,
        events: [],
      }
    );
    const evh_4449693688767071_input_2549 = new actions.EventHandlerImpl(
      {
        action: act_4449693688767071_script_2550,
        event: "input",
        displayName: "script",
      }
    );
    const evh_4449693688767071_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_4449693688767071_input_2549],
      }
    );
    const act_1548630417156826_script_2552 = new actions.ScriptAction(
      {
        actionArgs: this.act_1548630417156826_script_2552_getActionArgs,
        events: [],
      }
    );
    const evh_1548630417156826_clickPreventStop_2551 = new actions.EventHandlerImpl(
      {
        action: act_1548630417156826_script_2552,
        event: "click.prevent.stop",
        displayName: "script",
      }
    );
    const evh_1548630417156826_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1548630417156826_clickPreventStop_2551],
      }
    );
    const act_96700093353179_script_2554 = new actions.ScriptAction(
      {
        actionArgs: this.act_96700093353179_script_2554_getActionArgs,
        displayName: "addItem",
        events: [],
      }
    );
    const evh_96700093353179_clickPreventStop_2553 = new actions.EventHandlerImpl(
      {
        action: act_96700093353179_script_2554,
        event: "click.prevent.stop",
        displayName: "addItem",
      }
    );
    const evh_96700093353179_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_96700093353179_clickPreventStop_2553],
      }
    );
    return {
      act_5534025912102772_script_2542,
      evh_5534025912102772_input_2541,
      evh_5534025912102772_input,
      act_309515315410323_script_2544,
      evh_309515315410323_input_2543,
      evh_309515315410323_input,
      act_5188750589197515_script_2546,
      evh_5188750589197515_input_2545,
      evh_5188750589197515_input,
      act_3475726502813997_script_2548,
      evh_3475726502813997_input_2547,
      evh_3475726502813997_input,
      act_4449693688767071_script_2550,
      evh_4449693688767071_input_2549,
      evh_4449693688767071_input,
      act_1548630417156826_script_2552,
      evh_1548630417156826_clickPreventStop_2551,
      evh_1548630417156826_clickPreventStop,
      act_96700093353179_script_2554,
      evh_96700093353179_clickPreventStop_2553,
      evh_96700093353179_clickPreventStop,
      addItem: act_96700093353179_script_2554,
    }
  }
}

Vue.component("TransactionNotesEditor", TransactionNotesEditor);

</script>